import {
  FetchLifestyleCacheKey,
  FetchLifestyleGqlQuery,
  LifestyleID,
  LifestyleNanoID,
  LifestyleUUID
} from '../../lifestylesTypes';
import { FetchCacheItemSources, FetchItemGqlQuery } from '../../../../types';

import { useCacheShowQuery } from '../../../common/reactQuery/hooks/useCacheShowQuery';

import { LifestylesPermissions } from '../../lifestylesConstants';

interface CacheLifestyleFields {
  uuid: LifestyleUUID;
}

interface CacheLifestyleResponse<ItemType extends CacheLifestyleFields> {
  lifestyle: ItemType | null;
}

interface CacheLifestyleOptions {
  cacheKey: FetchLifestyleCacheKey;
  cacheQuery?: FetchItemGqlQuery;
  lifestyleNanoId: LifestyleNanoID | LifestyleID;
  options?: {
    cacheTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
  };
  query: FetchLifestyleGqlQuery;
  source?: FetchCacheItemSources;
}

const itemKey = 'lifestyle';

function useCacheLifestyle<ItemType extends CacheLifestyleFields>({
  cacheKey,
  cacheQuery,
  lifestyleNanoId,
  options = {},
  query,
  source
}: CacheLifestyleOptions) {
  const {
    item,
    itemError,
    itemErrorData,
    itemFetched,
    itemLoading,
    itemIsPlaceholderData,
    updateCacheShowQueryItemCache
  } = useCacheShowQuery<CacheLifestyleResponse<ItemType>, ItemType>({
    action: LifestylesPermissions.READ_LIFESTYLE_SHOW_ES_QUERY,
    cacheKey,
    cacheQuery,
    itemKey,
    options,
    query,
    source,
    uuid: lifestyleNanoId
  });

  return {
    lifestyle: item,
    lifestyleErrorData: itemErrorData,
    lifestyleError: itemError,
    lifestyleFetched: itemFetched,
    lifestyleLoading: itemLoading,
    lifestyleIsPlaceholderData: itemIsPlaceholderData,
    updateLifestyleCache: updateCacheShowQueryItemCache
  };
}

export default useCacheLifestyle;
